let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2Mq3f")).then(() => parcelRequire('6fjxX'));